import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { Toaster } from "sonner";
import "@/App.css";

// Global axios config: send auth cookies (httpOnly) with every request.
// The old Bearer token in localStorage still works during the migration —
// backend accepts cookie OR header, so users stay logged in through the deploy.
axios.defaults.withCredentials = true;
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AdminLayout from "@/components/AdminLayout";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import QuotePage from "@/pages/QuotePage";
import TrackingPage from "@/pages/TrackingPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminShipments from "@/pages/admin/AdminShipments";
import AdminPickups from "@/pages/admin/AdminPickups";
import AdminClients from "@/pages/admin/AdminClients";
import AdminDrivers from "@/pages/admin/AdminDrivers";
import AdminInvoicing from "@/pages/admin/AdminInvoicing";
import AdminTrasferte from "@/pages/admin/AdminTrasferte";
import AdminBrochure from "@/pages/admin/AdminBrochure";
import AdminDistinte from "@/pages/admin/AdminDistinte";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminDataGovernance from "@/pages/admin/AdminDataGovernance";
import AdminWarehouse from "@/pages/admin/AdminWarehouse";
import AdminWarehouseScan from "@/pages/admin/AdminWarehouseScan";
import AdminColloDetail from "@/pages/admin/AdminColloDetail";
import AdminLabels from "@/pages/admin/AdminLabels";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminReviews from "@/pages/admin/AdminReviews";
import DriverApp from "@/pages/DriverApp";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import CityPage from "@/pages/CityPage";
import BookPickupPage from "@/pages/BookPickupPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/servizi" element={<ServicesPage />} />
        <Route path="/chi-siamo" element={<AboutPage />} />
        <Route path="/contatti" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/preventivo" element={<QuotePage />} />
        <Route path="/tracking" element={<TrackingPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/trasporti/:slug" element={<CityPage />} />
        <Route path="/prenota-ritiro" element={<BookPickupPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Driver app */}
        <Route path="/autista" element={<DriverApp />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="contatti" element={<AdminContacts />} />
          <Route path="preventivi" element={<AdminQuotes />} />
          <Route path="spedizioni" element={<AdminShipments />} />
          <Route path="ritiri" element={<AdminPickups />} />
          <Route path="autisti" element={<AdminDrivers />} />
          <Route path="fatturazione" element={<AdminInvoicing />} />
          <Route path="trasferte" element={<AdminTrasferte />} />
          <Route path="presentazione" element={<AdminBrochure />} />
          <Route path="distinte" element={<AdminDistinte />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="impostazioni" element={<AdminSettings />} />
          <Route path="governance-dati" element={<AdminDataGovernance />} />
          <Route path="magazzino" element={<AdminWarehouse />} />
          <Route path="magazzino/scan" element={<AdminWarehouseScan />} />
          <Route path="magazzino/collo" element={<AdminColloDetail />} />
          <Route path="etichette" element={<AdminLabels />} />
          <Route path="clienti" element={<AdminClients />} />
          <Route path="audit-log" element={<AdminAuditLog />} />
          <Route path="recensioni" element={<AdminReviews />} />
        </Route>

        {/* Public routes */}
        <Route path="/*" element={<PublicLayout />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
